import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';
  
import { ClientsSocisComponent } from './clientssocis.component';
import { ClientsSocisFiltersComponent } from './clientssocis-filters/clientssocis-filters.component';
import { ManageClientsSocisComponent } from './manage-clientssocis/manage-clientssocis.component';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    ClientsSocisFiltersComponent,
    ManageClientsSocisComponent,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    ClientsSocisComponent,
    ManageClientsSocisComponent,
    ClientsSocisFiltersComponent
  ],
  exports: [
    ClientsSocisComponent
  ]
})
export class ClientsSocisModule { }
